import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { FichasObservacoesFixasModel } from "./observacoes-fixas.model";
import { FichasObservacoesFixasService } from './observacoes-fixas.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

@Component({
  selector: 'app-fichas-observacoes-fixas-form',
  templateUrl: './observacoes-fixas-form.component.html'
})
export class FichasObservacoesFixasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  observacao: FichasObservacoesFixasModel = new FichasObservacoesFixasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listCores = [];

  listReferencias = [
    { value: 'estivagem', label: '', translationKey: 'front.estivagem' },
    { value: 'paletizacao', label: '', translationKey: 'front.paletizacao' },
    { value: 'sem_rotulo', label: '', translationKey: 'front.semRotulo' },
    { value: 'embalagem_avariada', label: '', translationKey: 'front.embalagemDanificada' },
    { value: 'rotulo_divergente', label: '', translationKey: 'front.rotuloDivergente' },
    { value: 'peso_liquido_vol', label: '', translationKey: 'front.pesoLiquidoVol' },
    { value: 'calibre', label: '', translationKey: 'front.calibre' },
    { value: 'carga_avancada', label: '', translationKey: 'front.cargaAvancadaPorta' },
    { value: 'carga_tombada_porta', label: '', translationKey: 'front.cargaTombadaPorta' },
    { value: 'carga_avancada_teto', label: '', translationKey: 'front.cargaAvancadaTeto' },
    { value: 'odor', label: '', translationKey: 'front.odor' },
    { value: 'termografo_status', label: '', translationKey: 'front.termografo' },
    { value: 'termografo_inicializado', label: '', translationKey: 'front.termografoInicializado' },
    { value: 'termografo_encontrado', label: '', translationKey: 'front.termografoEncontrado' },
    { value: 'termografo_sem_dados_restritos', label: '', translationKey: 'front.termografoSemDadosRestritos' },
    { value: 'termografo_excesso_transit_time', label: '', translationKey: 'front.termografoTransitTimeExcesso' },
    { value: 'termografo_com_defeito', label: '', translationKey: 'front.termografoComDefeito' },
    { value: 'termografo_fora_alcance', label: '', translationKey: 'front.termografoForaAlcance' },
    { value: 'termografo_fora_tolerancia', label: '', translationKey: 'front.termografoForaTolerancia' },
    { value: 'temperatura_polpa_status', label: '', translationKey: 'front.temperatura_polpa_status' },
    { value: 'pressao_poupa_status', label: '', translationKey: 'front.pressao_poupa_status' },
    { value: 'brix_status', label: '', translationKey: 'front.brix_status' }
  ];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private observacoesFixasService: FichasObservacoesFixasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];

    this.form = formBuilder.group({
      id: [],
      referencia: [null, [
        Validators.required
      ]],
      observacao_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      observacao_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      observacao_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(5000)
      ]],
      cor: [0]
    });
  }

  ngOnInit() {
    this.listReferencias.forEach(item => {
      item.label = this.func.traduzir(item.translationKey);
    });

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_observacao_fixa'];

      if (!this.pageIsUpd) {
        this.title = 'Visualizar Observação Fixa';
      } else {
        this.title = id ? 'Editar Observação Fixa' : 'Adicionar Observação Fixa';
      }

      if (!id) {
        return;
      }

      this.observacoesFixasService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = 'Editar Observação Fixa: ' + json.Payload[0].observacao_pt;
            } else {
              this.title = 'Visualizar Observação Fixa: ' + json.Payload[0].observacao_pt;
            }

            this.observacao = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.observacoesFixasService.editar(values, values.id);
    } else {
      result = this.observacoesFixasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'observacoes-fixas']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/fichas-observacoes-fixas/observacoes-fixas-form.component.ts